import React, { Component } from 'react';
import client from './../../utils/apolloClient';
import { getUser } from './../../data-services/queries';
import gql from 'graphql-tag';
import getData, { pdfUpload, imageUpload } from './../../data-services/api';
import ImageGallery from '../../components/ImageGallery';
import Typography from '@material-ui/core/Typography';
import Grid from '@material-ui/core/Grid';
import Paper from '@material-ui/core/Paper';
import AppBar from '@material-ui/core/AppBar';
import Toolbar from '@material-ui/core/Toolbar';
import ArrowBackIcon from '@material-ui/icons/ArrowBack';
import IconButton from '@material-ui/core/IconButton';
import Loader from './../../components/CustomLoader';
import Swal from 'sweetalert2';
import noResultFoundImage from '../MyFCP/images/noResultFoundImage.png';
import pdfLogo from '../../components/Images/pdfLogo.png';
import { documentUpload } from './../../data-services/api/index';
import moment from 'moment';

const queryString = require('query-string');

export default class ETTCUpload extends Component {
    constructor(props) {
        super(props);
        this.state = {
            value: 3.5,
            FCPRating: 0,
            Uploaded_Content__c: [],
            loading: true,
            isDisabled: !!queryString.parse(window.location.search).id,
            AMMDApprovalPhoto: [],
            downloadEttcUrl: '',
            viewEttcUrl: '',
            ettcBase64URL: '',
            profile: {},
        };
    }

    async componentDidMount() {
        await client
            .query({
                query: gql(getUser),
            })
            .then(({ data }) => {
                if (data.user.role === 'FCP') {
                    this.setState({
                        userData: data.user,
                    });
                }
            });

        let ETTCUploadData;
        ETTCUploadData = await getData(
            `SELECT ettc_document__c, ettc_download__c
                FROM salesforce.account
                WHERE sfid = '${this.state.userData.sfid}' `
        );
        this.setState({
            downloadEttcUrl: ETTCUploadData.result[0].ettc_download__c,
            viewEttcUrl: ETTCUploadData.result[0].ettc_document__c,
            loading: false,
        });
    }

    handleAMMDPhotoUpload =
        (name) =>
        async ({ id, document, type, size }) => {
            // Alert if the uploaded file is not a PDF (like an image)
            if (!type.includes('pdf')) {
                //alert("Images or other files are not allowed. Please upload only PDF files.");
                Swal.fire({
                    icon: 'info',
                    title: 'Limitations Alert',
                    text: 'Images or other files are not allowed. Please upload only PDF files.',
                });
                return; // Stop further execution for non-PDF uploads
            }

            // Restrict the upload to only one PDF
            if (this.state.AMMDApprovalPhoto.length >= 1) {
                //alert("Only one PDF can be uploaded.");
                Swal.fire({
                    icon: 'info',
                    title: 'Limitations Alert',
                    text: 'Only one PDF can be uploaded.',
                });
                return; // Stop further execution if the limit is reached
            } else {
                this.setState({
                    loading: true,
                });
                var data;
                if (type.includes('image')) {
                    data = await imageUpload({
                        id: id,
                        img: document,
                        type: type,
                    });
                } else {
                    data = await pdfUpload({
                        id: id,
                        pdf: document,
                        type: type,
                    });
                }

                if (document) {
                    const dataUrl = document.split('base64,');
                    const blob = new Blob(
                        [Uint8Array.from(atob(dataUrl[1]), (c) => c.charCodeAt(0))],
                        { type: 'application/pdf' }
                    );
                    const openURL = URL.createObjectURL(blob);

                    // Open in a new tab
                    window.open(openURL, '_blank');
                }

                if (data && document) {
                    var base64 = document.replace('data:', '').replace(/^.+,/, '');
                    const URL = new Promise((resolve, reject) => {
                        const uploadImageQuery = `UPDATE salesforce.account SET 
                    ettc_document__c='${base64}',ettc_download__c='${data.url}'  WHERE sfid = '${this.state.userData.sfid}' `;
                        const result = getData(uploadImageQuery);
                        if (result) {
                            resolve(result);
                        } else reject(result);
                    });
                    URL.then((result) => {
                        if (result.status === 200) {
                            Swal.fire({
                                icon: 'success',
                                title: 'Your document uploaded successfully',
                                showConfirmButton: true,
                                confirmButtonColor: '#1a5c9a',
                            });
                            this.setState({
                                downloadEttcUrl: data.url,
                                viewEttcUrl: document,
                                loading: false,
                            });
                        }
                    });
                }
                this.setState({
                    loading: false,
                });
            }
        };

    openPDF = () => {
        const { viewEttcUrl } = this.state;
        if (viewEttcUrl) {
            // var dataUrl = viewEttcUrl.split('base64,')
            const blob = new Blob([Uint8Array.from(atob(viewEttcUrl), (c) => c.charCodeAt(0))], {
                type: 'application/pdf',
            });
            var openURL = URL.createObjectURL(blob);
            window.open(openURL, '_blank');
        } else {
            console.log('No URL found');
        }
    };

    gotoBack = () => {
        this.props.history.push({
            pathname: '/newHomeFCP',
        });
    };

    upload =
        (name) =>
        async ({ id, document, type, lastModifiedDate }) => {
            const data = await documentUpload({
                id: id,
                img: document,
                type: type,
                lastModifiedDate: lastModifiedDate,
            });

            if (!type.includes('image')) {
                alert('Only Images can be uploaded');
            } else {
                console.log('data', data);
                const new_date = moment();
                const formattedLastModifieDate = moment(new_date).format('YYYY-MM-DD HH:mm:ss');
                var insertImageQuery = `Insert Into Salesforce.Uploaded_Content__c (Name,Image_URL__c, Account__c)
                    values('Day-${formattedLastModifieDate}','${data.url}', '${this.state.userData.sfid}') 
                    returning id `;
                const insertedId = await getData(insertImageQuery);
                if (insertedId.result && insertedId.result !== false) {
                    Swal.fire({
                        icon: 'success',
                        title: 'Your Image is Uploaded successfully',
                        showConfirmButton: true,
                        confirmButtonColor: '#1a5c9a',
                    });
                    this.setState({
                        [name]: [
                            ...this.state[name],
                            {
                                id: insertedId.result[0].id,
                                url: data.url,
                                type,
                            },
                        ],
                    });
                } else {
                    alert('Image Upload Failed-' + insertImageQuery + '-' + insertedId);
                }
            }
        };

    delete = (name) => async (id) => {
        const deleteImageQuery = `delete from Salesforce.Workshop_Photo__c  where Workshop_Heroku_Id__c='${this.state.id}' and day__c='${this.state.day}' and type__c ='${name}' and id='${id}' returning id`;

        await getData(deleteImageQuery);
        const newState = this.state[name].filter((s) => {
            return s.id !== id;
        });
        this.setState({
            [name]: newState,
        });
    };

    render() {
        const { isDisabled, downloadEttcUrl, loading } = this.state;
        const { history } = this.props;

        return (
            <>
                <AppBar position="static">
                    <Toolbar>
                        <Grid item xs={2} sm={2} md={2}>
                            <IconButton
                                color="inherit"
                                aria-label="Menu"
                                onClick={() => {
                                    this.gotoBack();
                                }}
                            >
                                <ArrowBackIcon />
                            </IconButton>
                        </Grid>
                        <Grid item xs={8} sm={8} md={8}>
                            <Typography variant="title" color="inherit" className="text-center">
                                Upload your Submissions
                            </Typography>
                        </Grid>
                    </Toolbar>
                </AppBar>
                {loading ? (
                    <Grid container alignItems="center" justify="center">
                        <Loader type="Audio" color="#00BFFF" height="50" width="50" />
                    </Grid>
                ) : (
                    <>
                        <Paper elevation={1} style={{ padding: 7 }} square={true}>
                            <Grid container alignItems="center" justify="center">
                                <Grid item xs={4} md={4} style={{ paddingLeft: 15 }}>
                                    <Typography align="left" variant="body2">
                                        Upload submission
                                    </Typography>
                                </Grid>
                                <Grid item xs={8} md={8} style={{ paddingRight: 15 }}>
                                    <ImageGallery
                                        // disableAdd={!FCP}
                                        upload={this.upload('Uploaded_Content__c')}
                                        photos={this.state.Uploaded_Content__c}
                                        // delete={this.delete("Uploaded_Content__c")}
                                    />
                                </Grid>
                            </Grid>
                            <hr />
                            <Typography
                                variant="subtitle2"
                                align="center"
                                style={{ padding: 10 }}
                                onClick={() => {
                                    history.push({
                                        pathname: '/viewUploads',
                                        search: `?id=${this.state.userData.sfid}`,
                                        SFID: this.state.userData.sfid,
                                    });
                                }}
                            >
                                View Uploads
                            </Typography>

                            <hr />
                            <Grid container alignItems="center" justify="center">
                                <Grid item xs={4} md={4} style={{ paddingLeft: 15 }}>
                                    <Typography align="left" variant="body2">
                                        Upload ETTC Document ( PDF ONLY )
                                    </Typography>
                                </Grid>
                                <Grid item xs={8} md={8} style={{ paddingRight: 15 }}>
                                    <ImageGallery
                                        disableAdd={isDisabled}
                                        upload={this.handleAMMDPhotoUpload('AMMDApprovalPhoto')}
                                        photos={this.state.AMMDApprovalPhoto}
                                        // delete={this.handleDeletePhoto("AMMDApprovalPhoto")}
                                        single={true}
                                    />
                                </Grid>
                            </Grid>
                            <hr />
                            {downloadEttcUrl ? (
                                <>
                                    <Typography align="center" variant="body2">
                                        ETTC Uploaded Document
                                    </Typography>
                                    <Grid container alignItems="center" justify="center">
                                        <img
                                            src={pdfLogo}
                                            style={{
                                                marginTop: 10,
                                                width: '100px',
                                            }}
                                            alt="img"
                                        />
                                    </Grid>
                                    <hr />
                                    <Grid container alignItems="center" justify="center">
                                        <Grid item xs={6} md={6} style={{ paddingLeft: 15 }}>
                                            <Typography align="center" variant="body2">
                                                <a
                                                    href="/#"
                                                    role="button"
                                                    onClick={(e) => {
                                                        e.preventDefault(); // Prevent scrolling to top
                                                        this.openPDF();
                                                    }}
                                                    rel="noopener noreferrer"
                                                >
                                                    {' '}
                                                    View PDF{' '}
                                                </a>
                                            </Typography>
                                        </Grid>
                                        <Grid item xs={6} md={6} style={{ paddingRight: 15 }}>
                                            <Typography align="center" variant="body2">
                                                <a href={downloadEttcUrl} download="filename.pdf">
                                                    Download PDF
                                                </a>
                                            </Typography>
                                        </Grid>
                                    </Grid>
                                    {/* <div className='d-md-block'>
                                        <Grid container alignItems="center" justify="center">
                                            <iframe
                                                title="PDF Viewer"
                                                src={viewEttcUrl}
                                                width="100%"
                                                height="500px"
                                                allowfullscreen
                                            ></iframe>
                                        </Grid>
                                    </div> */}
                                </>
                            ) : (
                                <>
                                    <Grid
                                        container
                                        spacing={8}
                                        justify="center"
                                        alignItems="center"
                                    >
                                        <img
                                            style={{
                                                marginTop: '50px',
                                                width: 220,
                                                height: 190,
                                            }}
                                            src={noResultFoundImage}
                                            alt="img"
                                        />
                                    </Grid>
                                </>
                            )}
                        </Paper>
                    </>
                )}
            </>
        );
    }
}
